/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoSlackIcon20Solid = forwardRef('LogoSlackIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.5 2A1.5 1.5 0 0 0 10 3.5v4a1.5 1.5 0 0 0 3 0v-4A1.5 1.5 0 0 0 11.5 2Z" }),
        React.createElement("path", { d: "M15.75 5.5A1.75 1.75 0 0 0 14 7.25v1.361c0 .215.174.389.389.389h1.361a1.75 1.75 0 1 0 0-3.5Z" }),
        React.createElement("path", { d: "M16.5 10a1.5 1.5 0 0 1 0 3h-4a1.5 1.5 0 0 1 0-3h4Z" }),
        React.createElement("path", { d: "M14.5 15.75A1.75 1.75 0 0 0 12.75 14h-1.361a.389.389 0 0 0-.389.389v1.361a1.75 1.75 0 1 0 3.5 0Z" }),
        React.createElement("path", { d: "M10 16.5a1.5 1.5 0 0 1-3 0v-4a1.5 1.5 0 0 1 3 0v4Z" }),
        React.createElement("path", { d: "M4.25 14.5A1.75 1.75 0 0 0 6 12.75v-1.361A.389.389 0 0 0 5.611 11H4.25a1.75 1.75 0 1 0 0 3.5Z" }),
        React.createElement("path", { d: "M3.5 10a1.5 1.5 0 1 1 0-3h4a1.5 1.5 0 1 1 0 3h-4Z" }),
        React.createElement("path", { d: "M5.5 4.25C5.5 5.216 6.284 6 7.25 6h1.361A.389.389 0 0 0 9 5.611V4.25a1.75 1.75 0 1 0-3.5 0Z" })));
});
